import React, { useState, useEffect, useRef } from 'react';
import { DownIcon, UpIcon } from 'tt-ui-lib/icons';
import styles from './NestedSelect.module.scss';
import { useSearchParams } from 'react-router-dom';

const NestedSelect = ({ options, setActiveTab, activeTab, setActiveChildTab, activeChildTab }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openDropdownChildIndex, setOpenDropdownChildIndex] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const wrapperRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  const selectDropdownItem = (index) => {
    setActiveTab(index);
    const activeTabName = options[index].name;
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('activeTab', activeTabName);
    if (!options[index].child || (options[index].child && !options[index].child.length)) {
      setOpenDropdown(false);
      setOpenDropdownChildIndex(null);
      if (options[index].child && options[index].child.length) {
        setActiveChildTab(0);
        const activeChildTabName = options[index].child[0]?.name;
        newSearchParams.set('activeChildTab', activeChildTabName);
      }
    } else {
      newSearchParams.delete('activeChildTab');
      if (openDropdownChildIndex === index) {
        setOpenDropdownChildIndex(null);
      } else {
        setOpenDropdownChildIndex(index);
      }
      if (activeTab !== index) {
        setActiveChildTab(0);
      }
    }
    setSearchParams(newSearchParams);
  };

  const selectChildDropdownItem = (index) => {
    setActiveChildTab(index);
    const activeChildTabName = options[activeTab].child[index].name;
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set('activeChildTab', activeChildTabName);
    setSearchParams(newSearchParams);
    setOpenDropdown(false);
  };

  return (
    <div ref={wrapperRef} className={styles.dropdownContainer}>
      <div
        className={styles.dropdownInput}
        style={openDropdown ? { borderRadius: '16px 16px 0 0' } : {}}
        onClick={() => setOpenDropdown((current) => !current)}
      >
        <div>{`${options[activeTab].name} ${
          options[activeTab].child && options[activeTab].child.length > 0
            ? ` - ${options[activeTab].child[activeChildTab].name}`
            : ''
        }`}</div>
        {openDropdown ? (
          <UpIcon style={{ width: 14, height: 14, marginTop: '-4px' }} />
        ) : (
          <DownIcon style={{ width: 14, height: 14, marginTop: '-4px' }} />
        )}
      </div>
      {openDropdown && (
        <div className={styles.dropdownOptions}>
          {options.map((item, index) => (
            <div key={item.name}>
              <div>
                <div
                  className={styles.dropdownOptionBlock}
                  onClick={() => selectDropdownItem(index)}
                >
                  <div
                    className={styles.dropdownOptionName}
                    style={
                      activeTab === index ? { color: '#143471', fontWeight: 700, fontSize: 16 } : {}
                    }
                  >
                    {item.name}
                  </div>
                </div>
                {openDropdownChildIndex === index && (
                  <div>
                    {item.child.map((childItem, childIndex) => (
                      <div
                        onClick={() => selectChildDropdownItem(childIndex)}
                        key={childItem.name}
                        style={
                          activeChildTab === childIndex
                            ? { color: '#143471', fontWeight: 700, fontSize: 16 }
                            : {}
                        }
                        className={styles.dropdownChildOptionName}
                      >
                        {childItem.name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default NestedSelect;
